import React from "react"

import TodoModal from "../../student/activity/todo/TodoModal"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { draftToTodoShape } from "./draftToTodoShape"

/**
 * A Sam proposal opens like any other activity: the same TodoModal, in
 * draft mode. `id` stays absent — TodoModal's draftMode gate skips every
 * API path that would use it — and `draftToTodoShape` grafts the fields
 * ActivityItemInfo expects, so the header looks identical to a real todo
 * entry.
 */
const DraftPreviewModal = ({
    preview,
    students,
    draftsByStudentId,
    schoolSubjects,
    navigation,
    onClose,
}) => {
    if (!preview) return null

    const previewStudent = students.find(
        (s) => s.student_id === preview.studentId
    )
    if (!previewStudent) return null

    const previewDraft = draftsByStudentId[preview.studentId]
    const previewActivity =
        previewDraft?.activities?.[preview.activityIndex] ?? null
    if (!previewActivity) return null

    const leadMaterial = previewActivity?.material ?? null
    const itemForTodo = draftToTodoShape(previewActivity)

    return (
        <TodoModal
            isOpen
            handleShowModal={onClose}
            onExit={onClose}
            onRequestClose={onClose}
            item={itemForTodo}
            studentId={previewStudent.student_id}
            student={{
                id: previewStudent.student_id,
                firstname: previewStudent.firstname,
                display_name: previewStudent.display_name,
                avatar: previewStudent.avatar,
                profile: { class: leadMaterial?.class ?? null },
            }}
            schoolSubject={findItemInListWithId(
                itemForTodo.school_subject_id,
                schoolSubjects
            )}
            navigation={navigation}
            draftMode
        />
    )
}

export default DraftPreviewModal
